import React from "react";
import { LanguageProvider } from "../contexts/LanguageContext";
import { Navbar } from "../components/sections/Navbar";
import { TopBar } from "../components/sections/TopBar";
import { Hero } from "../components/sections/Hero";
import { Trust } from "../components/sections/Trust";
import { About } from "../components/sections/About";
import { WhyChoose } from "../components/sections/WhyChoose";
import { Packages } from "../components/sections/Packages";
import { SpecialOffer } from "../components/sections/SpecialOffer";
import { Gallery } from "../components/sections/Gallery";
import { InstagramFeed } from "../components/sections/InstagramFeed";
import { Booking } from "../components/sections/Booking";
import { Footer } from "../components/sections/Footer";
import { WhatsAppFloat } from "../components/sections/WhatsAppFloat";
import { CookieConsent } from "../components/sections/CookieConsent";

export default function Home() {
  return (
    <>
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <Trust />
        <About />
        <WhyChoose />
        <SpecialOffer />
        <Packages />
        <Gallery />
        <InstagramFeed />
        <Booking />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CookieConsent />
    </>
  );
}

// Re-export for usage where LanguageProvider isn't already provided
export { LanguageProvider };
